import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fence-calculator',
  component: () => import('../../routes/FenceCalculator.svelte'),
  card: {
    id: 'fence-calculator',
    title: 'Fence Calculator',
    description:
      'Calculate the number of posts, rails, pickets, and concrete bags needed to build a wood fence. Supports privacy, picket, shadowbox, and ranch styles with optional gate.',
    icon: 'fence',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/fence-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Fence Calculator – Estimate Posts, Rails, Pickets, and Cost',
    description:
      'Free fence material calculator. Estimate posts, rails, pickets, concrete bags, and total cost for privacy, picket, shadowbox, and ranch-style wood fences with an optional gate.',
  },
};

export default meta;
